// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__omo14","right":"styles_right__3cQfX"};